// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const token = "Bearer " + localStorage.getItem("token");
export const environment = {
  production: false,
  // OJO: por defecto apunta a PRODUCCION. Para trabajar en local, comentar la de
  // arriba y descomentar la de abajo (backend en el 3001).
  // apiurl: "https://bureauveritas.softadp.com/api",
  apiurl: "https://bureauveritas.softadp.com/api",
  tokenautorization:token,
  logWebSockets: true,
  apiurlFileStorage: "https://4f0d-186-154-168-111.ngrok-free.app/api",
  apiurlFile:true,
  //apiurlFile: "https://mecm.appgip.com/api-storage-mecm",

  // Servicio de documentos (plantillas .docx). Corre aparte del api principal:
  // en desarrollo se apunta directo a su puerto; en produccion ira detras del
  // mismo dominio via proxy. Ver environmentProd.ts.
  apiurlDocuments: "https://4f0d-186-154-168-111.ngrok-free.app/api/documents",
};



